import * as types from '../mutation-types'
import { IsBuy } from '@/api/detailPage'
import { Toast, MessageBox } from 'mint-ui'

// initial state
const state = {
  soHoInfo: null
}

// getters
const getters = {
  getSoHoInfo: state => state.soHoInfo
}

// mutations
const mutations = {
  [types.SET_SOHO_INFO](state, soHoInfo) {
    state.soHoInfo = soHoInfo
  }
}
// actions
const actions = {
  getIsBuy({ commit }, productId) {
    return new Promise((resolve, reject) => {
      IsBuy({ productId: productId }).then(res => {
        resolve(res.Data)
      }).catch((err) => {
        reject(err)
      })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
